import { useQuery } from '@tanstack/react-query';
import { getApproverAccess } from '../services/api/implementation/impl';

/**
 * What the signed-in person may give final approval to.
 *
 * Owner-ness is decided by the server (`GET /approvals/me`), not by cookies:
 * the owner is the builder's primary user, and the people he trusts can sit in
 * any vertical. `loaded` is false until the answer arrives, and stays false if
 * the call fails — callers keep today's behaviour then and let the server
 * refuse, rather than locking somebody out on a network blip.
 */
export function useApproverAccess() {
  const query = useQuery({
    queryKey: ['approverAccess'],
    queryFn: getApproverAccess,
    staleTime: 5 * 60 * 1000,
    retry: false
  });

  const data = query.data ?? null;
  const isOwner = Boolean(data?.is_owner);
  const types = Array.isArray(data?.types) ? data.types : [];

  return {
    loaded: Boolean(data),
    failed: query.isError,
    isOwner,
    types,
    labels: data?.labels ?? {},
    isApprover: isOwner || types.length > 0,
    canApprove: (type) => isOwner || types.includes(type)
  };
}

export const APPROVAL_TYPE_LABEL = {
  LABOUR_PAYMENT: 'Wage payments',
  PAYROLL: 'Payroll',
  WAGE_RATE_CHANGE: 'Wage rate changes'
};
